const regex = {
  EMAIL_REGEX_PATTERN:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  NUMERIC_ONLY: /^(0|[1-9][0-9]*)$/,
  NUMERIC_ONLY_EXACT_LENGTH_9: /^([0-9]{9})$/,
  NUMERIC_BETWEEN_0_AND_100: /^(?:100(?:\.0{1,2})?|(?:\d{1,2}(?:\.\d{1,2})?))$/,
  NUMERIC_POSITIVE_ONLY: /^[0-9][0-9]*$/,
  INTEGER_NUMBERS_ONLY: /^[0-9]*$/,
  ONLY_NUMBER_AND_DECIMALS: /^([-+]?\d{1,3}(,\d{3})*(\.\d+)?|[-+]?\d+(\.\d+)?|\d{1,3}(.\d{3})*(,\d+)?)$/,
  ZIP_CODE_REGEX_PATTERN: /^[A-Za-z0-9\s-]+$/,
  POSTAL_CODE_REGEX_PATTERN: /^(?!.*[dfioquDFIOQU])[a-vxyA-VXY]\d[a-zA-Z](\s\d[a-zA-Z]\d)?$/,
  NUMERIC_ONLY_EXACT_LENGTH_10: /^(\+1)?[-]?([0-9]{3})\)?[-]?([0-9]{3})[-]?([0-9]{4})$/,
  PHONE_FAX_REGEX_PATTERN: /^(?=.*?\d)[\d\s()+\-*#]{1,20}[+-]?$/,
  PASSWORD_REGEX_PATTERN:
    /^(?=(?:.*[A-Z]))(?=(?:.*[a-z]))(?=(?:.*\d))(?=(?:.*[!@#$%^&*()\-_=+{};:,<.>]))([A-Za-z0-9!@#$%^&*()\-_=+{};:,<.>]{8,20})$/,
  INVOICE_AMOUNT_REGEX: /^\d{1,17}(\.\d{0,2})?$/,
  MC_NUMBER_REGEX_PATTERN: /^(MC\s?)?\d{1,20}$/i,
}

export default regex
